var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketScans(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 9V3H9V5.4H5.4V9H3ZM3 27V21H5.4V24.6H9V27H3ZM21 27V24.6H24.6V21H27V27H21ZM24.6 9V5.4H21V3H27V9H24.6ZM21.6 21.6H23.4V23.4H21.6V21.6ZM21.6 18H23.4V19.8H21.6V18ZM19.8 19.8H21.6V21.6H19.8V19.8ZM18 21.6H19.8V23.4H18V21.6ZM16.2 19.8H18V21.6H16.2V19.8ZM19.8 16.2H21.6V18H19.8V16.2ZM18 18H19.8V19.8H18V18ZM16.2 16.2H18V18H16.2V16.2ZM23.4 6.6V13.8H16.2V6.6H23.4ZM13.8 16.2V23.4H6.6V16.2H13.8ZM13.8 6.6V13.8H6.6V6.6H13.8ZM12 21.6V18H8.4V21.6H12ZM12 12V8.4H8.4V12H12ZM21.6 12V8.4H18V12H21.6Z",
    fill: "#0057FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketScans);
export default __webpack_public_path__ + "static/media/TicketScans.e060407b5de60fdb06d219aedae2d70e.svg";
export { ForwardRef as ReactComponent };